import { IN_APP } from 'constants/messageMediums';
import { selectFeatureFlags, selectUserRbacPermissions } from 'core/userContext';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { BUTTON_SIZES, PrimaryButton, SecondaryButton } from 'ui/button';
import { ChevronDown16, Export16, Link16 } from 'ui/icons';
import { Menu } from 'ui/menu';
import { Tooltip } from 'ui/tooltip';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { getCampaignDetailsLink } from '../utils';
import { CampaignAnalyticsOverflowMenu } from './CampaignAnalyticsOverflowMenu';
import { ShareUrlPopUp } from './ShareUrlPopUp';
import { CleanAnchor, StyledPageActions } from './Styled';

export const PageActions = ({
  campaignMetadata,
  onViewAlerts,
  setIsExportModalOpen,
  setIsExportInAppEventModalOpen,
}) => {
  const featureFlags = useSelector(selectFeatureFlags);
  const permissions = useSelector(selectUserRbacPermissions);
  const isCampaignPerformanceAlertsEnabled = featureFlags.CampaignPerformanceAlerts;
  const isCampaignPerformanceAlertsHistoryEnabled = featureFlags.CampaignPerformanceAlertsHistory;
  const canViewAndExpUserData = permissions.includes(PROJECT_PERMISSIONS.ViewAndExportUserData);
  const campaignId = campaignMetadata?.id;

  const [shareUrlOpen, setShareUrlOpen] = useState(false);

  const overflowActions = {
    'export-events-modal': () => setIsExportModalOpen(true),
    'export-inapp-events': () => setIsExportInAppEventModalOpen(true),
  };

  return (
    <StyledPageActions>
      {isCampaignPerformanceAlertsEnabled && isCampaignPerformanceAlertsHistoryEnabled ? (
        <CampaignAnalyticsOverflowMenu
          campaignMetadata={campaignMetadata}
          onViewAlerts={onViewAlerts}
        />
      ) : (
        <CleanAnchor
          href={getCampaignDetailsLink({
            campaignMetadata,
            campaignId,
          })}
        >
          <SecondaryButton size={BUTTON_SIZES.LARGE}>View campaign</SecondaryButton>
        </CleanAnchor>
      )}
      <Tooltip
        isEnabled={!canViewAndExpUserData}
        tooltipContent="You do not have permission to export user data."
      >
        {featureFlags?.WebInAppReporting && campaignMetadata?.messageMedium === IN_APP ? (
          <Menu
            isDisabled={!canViewAndExpUserData}
            handleSelectionChange={(id) => id && overflowActions[id]()}
            options={[
              { label: 'Export events', id: 'export-events-modal' },
              { label: 'Export in-app events by destination', id: 'export-inapp-events' },
            ]}
          >
            <SecondaryButton size={BUTTON_SIZES.LARGE}>
              <Export16 /> Export events <ChevronDown16 />
            </SecondaryButton>
          </Menu>
        ) : (
          <SecondaryButton
            isDisabled={!canViewAndExpUserData}
            size={BUTTON_SIZES.LARGE}
            onClick={() => setIsExportModalOpen(true)}
          >
            <Export16 /> Export events
          </SecondaryButton>
        )}
      </Tooltip>
      {featureFlags?.ExportUrlFiltersCA && (
        <div>
          <PrimaryButton
            size={BUTTON_SIZES.LARGE}
            onClick={() => {
              setShareUrlOpen(!shareUrlOpen);
            }}
          >
            <Link16 />
            <span>Share</span>
          </PrimaryButton>
          {shareUrlOpen && <ShareUrlPopUp setIsOpen={setShareUrlOpen} />}
        </div>
      )}
    </StyledPageActions>
  );
};
